module.exports = __webpack_public_path__ + "static/media/F59B3CLasAA3Mei.ef0ac9fa.webp";